import { render, staticRenderFns } from "./DataImportLogsForm.vue?vue&type=template&id=57859444&scoped=true"
import script from "./DataImportLogsForm.vue?vue&type=script&lang=js"
export * from "./DataImportLogsForm.vue?vue&type=script&lang=js"
import style0 from "./DataImportLogsForm.vue?vue&type=style&index=0&id=57859444&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57859444",
  null
  
)

export default component.exports